import React, { useMemo, useCallback } from 'react'
import { dialogTypes } from '@/dialogs'
import context from '@/context'
import { NameColumn, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { PropertyRenderer } from '@/components/changeRequests'
import { useLocalization } from '@/hooks/localization'
import { usePropertyReader } from '@/hooks/usePropertyReader'
import { institutionPermissionTypes } from '@/enums/institutionPermissionTypes'
import { PermissionSectionProvider } from '@/components/changeRequests/institutionPermissionProvider'
import { individualPermissionTypes } from '@/enums/individualPermissionTypes'
import { IndividualPermissionProvider } from '@/components/changeRequests/individualPermissionProvider'

const IndividualBlacklists = React.memo(function IndividualBlacklists ({ dataSource }) {
  return (
    <IndividualPermissionProvider individualPermission={individualPermissionTypes.enum.IndividualBlacklists}>
      <Blacklists dataSource={dataSource} />
    </IndividualPermissionProvider>
  )
})

const InstitutionBlacklists = React.memo(function InstitutionBlacklists ({ dataSource }) {
  return (
    <PermissionSectionProvider institutionPermission={institutionPermissionTypes.enum.Blacklists}>
      <Blacklists dataSource={dataSource} />
    </PermissionSectionProvider>)
})

const Blacklists = React.memo(function Blacklists () {
  const { localize, locale } = useLocalization()
  const [personId] = usePropertyReader(['personId'])
  const dataSource = useCallback((request, opts) => context.api.blacklistRecordService.getTableDataByPersonId(personId, request, opts), [personId])
  const detailDialog = useMemo(() => ({ dialogType: dialogTypes.blacklistDetail, loadData: context.api.blacklistRecordService.get }), [])
  return (
    <PropertyRenderer name='blacklists' inputType='grid' dataSource={dataSource}
      detailDialog={detailDialog} readonly>
      <Column field='personName' title={localize('Blacklists.PersonName')} editable={false} />
      <Column field='personLatinName' title={localize('Blacklists.PersonLatinName')} editable={false} />
      {NameColumn({ locale, nameProp: 'blacklistName', latinNameProp: 'blacklistLatinName', title: localize('Blacklists.Type'), editable: false })}
      <Column field='validFrom' title={localize('Common.ValidFrom')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
      <Column field='validTo' title={localize('Common.ValidTo')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
    </PropertyRenderer>
  )
})

export { IndividualBlacklists, InstitutionBlacklists }



// WEBPACK FOOTER //
// ./src/components/demographics/blacklists.js